module.exports = __webpack_public_path__ + "img/add-card-referall-programe.baa274cb.svg";